<script lang="ts" setup>
  import type { PropType } from 'vue';
  import type { Photo } from '@storefront/resources';

  type Item = {
    header: string | null;
    headerType: string;
    link: string | null;
    photos: Photo[];
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    items: { type: Array as PropType<Item[]>, required: true, default: [] },
    header: String,
    headerType: String,
  });
</script>
<template>
  <SfSection v-if="items.length > 0" :title="header" :headerType>
    <div class="icon-text-block">
      <article v-for="item in items" class="icon-text-block__tile">
        <MediaPicture :photo="item.photos?.[0]" type="icon" sizes=" 80x80 2x, 40x40" />
        <SfHeading v-if="item.header" :type="item.headerType ?? 'h3'" v-html="item.header" class="icon-text-block__heading" />
      </article>
    </div>
  </SfSection>
</template>
<style lang="scss" scoped>
  .icon-text-block {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;

    &__tile {
      position: relative;
      display: flex;
      align-items: center;
      gap: 1rem;

      :deep(img) {
        height: 2.5rem;
        aspect-ratio: 1;
      }
    }

    @media (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media(max-width: 768px) {
      padding: 0 0.625rem;
      gap: 1rem;

      &__tile {
        gap: 0.5rem;
      }
    }

    @media(max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }
</style>
